import React from 'react';
import styled, { css } from 'styled-components';
import Img from 'gatsby-image';
import Hammer from 'react-hammerjs';

import scale from '../utils/scale';
import media from '../utils/mediaQueries';

import Button from '../atoms/Button';
import FullHeightContent from './FullHeightContent';

const isBrowser = typeof window !== 'undefined';

const buttonStyles = css`
  position: absolute;
  top: 50%;
  margin-top: -${props => scale(props.theme.height.buttonHeightMobile / 2)};
  pointer-events: all;

  ${props =>
    props.fullscreen &&
    `
    top: calc(50% + ${scale(props.theme.height.sidebarMobile / 2)});
  `}

  ${media.md`
    top: 50%;
    margin-top: -${props => scale(props.theme.height.buttonHeight / 2)};
  `}
`;

const ButtonNext = styled(Button)`
  ${buttonStyles}

  right: 0;

  ${props =>
    props.fullscreen &&
    `
    right: ${scale(1.5)};
  `}
`;

const ButtonPrev = styled(Button)`
  ${buttonStyles}

  left: 0;

  ${props =>
    props.fullscreen &&
    `
    left: ${scale(1.5)};
  `}
`;

const Wrapper = styled(Hammer)`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
`;

const Slide = styled(FullHeightContent)`
  display: none;

  ${props =>
    props.active &&
    `
    display: flex;
  `}

  * {
    margin: 0 auto;
  }
`;

export default class Slideshow extends React.Component {
  prevSlide = () => {
    const { slides, handleSlideChange, showSlide } = this.props;
    const activeSlide = typeof showSlide === 'undefined' ? 1 : showSlide;
    const prevSlide = activeSlide > 1 ? activeSlide - 1 : slides.length;

    handleSlideChange(prevSlide);
  };

  nextSlide = () => {
    const { slides, handleSlideChange, showSlide } = this.props;
    const activeSlide = typeof showSlide === 'undefined' ? 1 : showSlide;
    const nextSlide = activeSlide < slides.length ? activeSlide + 1 : 1;

    handleSlideChange(nextSlide);
  };

  onKeydown = e => {
    // arrow left
    if (e.which === 37) {
      e.preventDefault();
      this.prevSlide();
    }

    // arrow right
    if (e.which === 39) {
      e.preventDefault();
      this.nextSlide();
    }
  };

  componentDidMount() {
    if (isBrowser) {
      window.addEventListener('keydown', this.onKeydown);
    }
  }

  componentWillUnmount() {
    if (isBrowser) {
      window.removeEventListener('keydown', this.onKeydown);
    }
  }

  render() {
    const {
      slides,
      fullscreen,
      showSlide,
      relativeHeightXs,
      relativeHeightMd,
    } = this.props;

    const activeSlide = typeof showSlide === 'undefined' ? 1 : showSlide;

    return (
      <Wrapper onSwipeLeft={this.nextSlide} onSwipeRight={this.prevSlide}>
        <div>
          {slides.map((slide, index) => (
            <Slide
              relativeHeightXs={relativeHeightXs}
              relativeHeightMd={relativeHeightMd}
              key={slide.id}
              active={index === activeSlide - 1}
              ratio={slide.data.ratio}
            >
              {slide.type === 'image' && (
                <Img fluid={slide.data.fluid} alt={slide.data.alt} />
              )}
            </Slide>
          ))}

          {slides.length > 1 && (
            <>
              <ButtonNext
                icon="arrowsRight"
                onClick={this.nextSlide}
                fullscreen={fullscreen}
              />
              <ButtonPrev
                icon="arrowsLeft"
                onClick={this.prevSlide}
                fullscreen={fullscreen}
              />
            </>
          )}
        </div>
      </Wrapper>
    );
  }
}
